import React, {Component} from 'react';
import {Grid, Row, Col, Form, FormGroup, ControlLabel, Radio, FormControl} from "react-bootstrap";
import ReactNotify from 'react-notify';
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import moment from 'moment'
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopButtonAction, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import DateAndTimeUtilities from "../../../../../utilities/DateAndTimeFormat";
import ObsadaService from "../ObsadaService";
import TopSelectSlownik from "../../../../../componentsTopsa/selects/TopSelectSlownik";
import AppConfig from "../../../../../AppConfig";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import Validator from "../../../../../utilities/Validator";

export default class ObsadaZamianaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: 1,
            dataOd: moment(),
            dataDo: moment(),

            powod: null,
            uwagi: '',
            starykierowca: null,
            nowykierowca: null,
            starypojazd: null,
            nowypojazd: null,
            typplatnosci: null,
            stawka: '',

        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeUwagi = this.onChangeUwagi.bind(this)

        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onChangeUwagi(e) {
        if (e.target.value.length <= 100) {
            this.setState({uwagi: e.target.value})
        } else {
            document.getElementById('inputUwagi').value = this.state.uwagi
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validateMessages;
        arr.push(msg)
        this.setState({validateMessages: arr})
    }

    onClickZapisz() {

        let poprawne = true;
        this.state.validateMessages = []

        if (this.state.dataOd > this.state.dataDo) {
            poprawne = false;
            this.dodajDoValidatorMessages('Data od nie może być poźniejsza niż data do')
        }

        if (!Boolean(this.state.powod)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano powodu zmiany')
        }

        if (this.state.checked === 1) {
            if (!Boolean(this.state.starykierowca)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano zamienianego kierowcy')
            }
            if (!Boolean(this.state.nowykierowca)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano nowego kierowcy')
            }
            if (!Boolean(this.state.typplatnosci)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano typu płatności')
            } else {
                if (this.state.typplatnosci.wartosc == 'EXTRA') {
                    if (!Boolean(this.state.stawka)) {
                        poprawne = false;
                        this.dodajDoValidatorMessages('Wybierając typ płatności EXTRA należy uzupełnić stawkę')
                    }
                    else {
                        if (!Validator.validateIntOrDouble(this.state.stawka)) {
                            poprawne = false;
                            this.dodajDoValidatorMessages('Wartość stawki jest niepoprawna')
                        }
                        if (parseFloat(this.state.stawka) < 0) {
                            poprawne = false;
                            this.dodajDoValidatorMessages('Wartość stawki jest ujemna')
                        }
                    }
                }
            }

        }
        else {
            if (!Boolean(this.state.starypojazd)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano zamienianego pojazdu')
            }
            if (!Boolean(this.state.nowypojazd)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano nowego pojazdu')
            }
        }

        if (window.confirm('Czy na pewno chcesz wykonać akcję?')) {
            if (poprawne) {
                let params =
                    "?dataOd=" + DateAndTimeUtilities.formatYYYYMMDD(this.state.dataOd) +
                    "&dataDo=" + DateAndTimeUtilities.formatYYYYMMDD(this.state.dataDo) +
                    '&powodZam=' + this.state.powod.wartosc + '&uwagi=' + this.state.uwagi

                if (this.state.checked === 1) {
                    let stawka = 0;
                    if (this.state.typplatnosci.wartosc == 'EXTRA') {
                        stawka = parseFloat(this.state.stawka)
                    }

                    params = params +
                        '&idKiZ=' + this.state.starykierowca.idKi +
                        '&idKiNa=' + this.state.nowykierowca.idKi +
                        '&typPlat=' + this.state.typplatnosci.wartosc +
                        '&stawka=' + stawka
                } else {
                    params = params +
                        '&idPoZ=' + this.state.starypojazd.idPo +
                        '&idPoNa=' + this.state.nowypojazd.idPo
                }

                console.log(params)

                ObsadaService.zamienZasobyObsada(params)
                    .then(function (response) {

                        this.setState({
                            checked: 1,
                            dataOd: moment(),
                            dataDo: moment(),
                            powod: null,
                            uwagi: '',
                            starykierowca: null,
                            nowykierowca: null,
                            starypojazd: null,
                            nowypojazd: null,
                            typplatnosci: null,
                            stawka: '',
                            validateMessages: []
                        })

                        if (response.status < 300) {
                            this.refs.notificator.success('Pomyślnie zapisano zmianę', "", 3000)
                            this.props.handlePobierzObsade();
                        }
                        else {
                            this.refs.notificator.error('Wystąpił błąd podczas wprowadzania zmiany', "", 3000)
                        }
                    }.bind(this))
                    .catch(function (err) {
                        this.refs.notificator.error('Wystąpił błąd podczas wprowadzania zmiany', "", 3000)

                    }.bind(this))
            }

        }
    }

    renderPojazdSelect(option) {
        return (
            <div>
                <span>{option.informacje}</span>
                <div className={'pull-right'}>
                    {
                        Boolean(option.status) ?
                            <span style={{fontSize: '12px', color: 'forestgreen'}}><i className={'fa fa-check'}></i> aktywny</span>
                            :
                            <span style={{fontSize: '12px', color: 'firebrick'}}><i className={'fa fa-times'}></i> nieaktywny</span>

                    }
                </div>
            </div>
        )
    }

    renderKierowcaSelect(option) {
        return <div>
            <span>{option.informacje}</span>
            <div className={'pull-right'}>
                {
                    (option.status == 1) ?
                        <span style={{fontSize: '12px', color: 'forestgreen'}}><i className={'fa fa-check'}></i> aktywny</span>
                        :
                        <span style={{fontSize: '12px', color: 'firebrick'}}><i className={'fa fa-times'}></i> nieaktywny</span>
                }
            </div>
        </div>
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <div>
                    <Row>
                        <Col xs={12} lg={12}>
                            <fieldset>
                                <div className={'fieldset-label'}>Wprowadz zmianę w obsadzie</div>
                                <Form horizontal={true}>
                                    <FormGroup>
                                        <Col xs={12} lg={2}>
                                            <ControlLabel>Data od</ControlLabel>
                                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                                        </Col>
                                        <Col xs={12} lg={2}>
                                            <ControlLabel>Data do</ControlLabel>
                                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                                        </Col>
                                        <Col xs={12} lg={4}>
                                            <ControlLabel>Zasoby do zamiany</ControlLabel>
                                            <div>
                                                <Radio name="radioGroup" inline checked={Boolean(this.state.checked === 1)}
                                                       onClick={() => this.setState({
                                                           checked: 1,
                                                           powod: null,
                                                           uwagi: '',
                                                           starykierowca: null,
                                                           nowykierowca: null,
                                                           starypojazd: null,
                                                           nowypojazd: null,
                                                           typplatnosci: null,
                                                           stawka: '',
                                                       })}>
                                                    kierowcy
                                                </Radio>{' '}
                                                <Radio name="radioGroup" inline checked={Boolean(this.state.checked === 2)}
                                                       onClick={() => this.setState(
                                                           {
                                                               checked: 2,
                                                               powod: null,
                                                               uwagi: '',
                                                               starykierowca: null,
                                                               nowykierowca: null,
                                                               starypojazd: null,
                                                               nowypojazd: null,
                                                               typplatnosci: null,
                                                               stawka: ''
                                                           })}>
                                                    pojazdy
                                                </Radio>
                                            </div>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup>
                                        {
                                            this.state.checked === 1 ?
                                                <Col xs={12} lg={3}>
                                                    <ControlLabel>
                                                        Zmieniany kierowca
                                                    </ControlLabel>
                                                    <TopSelect onChange={(e) => this.setState({starykierowca: e})}
                                                               value={this.state.starykierowca}
                                                               options={this.props.kierowcy}
                                                               valueKey={'idKi'} labelKey={'informacje'}
                                                               optionRenderer={this.renderKierowcaSelect}
                                                               valueRenderer={this.renderKierowcaSelect}
                                                    />
                                                </Col>
                                                :
                                                <Col xs={12} lg={4}>
                                                    <ControlLabel>Zamieniany pojazd</ControlLabel>
                                                    <TopSelect onChange={(e) => this.setState({starypojazd: e})}
                                                               value={this.state.starypojazd}
                                                               options={this.props.pojazdy}
                                                               valueKey={'idPo'} labelKey={'informacje'}
                                                               optionRenderer={this.renderPojazdSelect}
                                                               valueRenderer={this.renderPojazdSelect}
                                                    />
                                                </Col>
                                        }

                                        <Col xs={12} lg={this.state.checked === 1 ? 2 : 3}>
                                            <ControlLabel>
                                                Powód zamiany
                                            </ControlLabel>
                                                    <TopSelectSlownik restUrl={AppConfig.HOST_API() + 'slownik/byNazwa/OBSADA_POWOD_ZAMIANA'}
                                                                      onChange={(e) => this.setState({powod: e, uwagi: ''})}
                                                                      valueKey={'id'} labelKey={'wartosc'}
                                                    />
                                        </Col>
                                        <TopIf isTrue={Boolean(this.state.powod) ? this.state.powod.wartosc == 'INNE' : false}>
                                            <Col xs={12} lg={4}>
                                                <ControlLabel>
                                                    Uwagi <span style={{
                                                    fontSize: '12px',
                                                    color: 'grey',
                                                    fontStyle: 'italic',
                                                    fontWeight: 'normal'
                                                }}>{this.state.uwagi.length}/100 znaków</span>
                                                </ControlLabel>
                                                <FormControl type={'text'} onChange={this.onChangeUwagi} id={'inputUwagi'}/>
                                            </Col>
                                        </TopIf>
                                    </FormGroup>
                                    {
                                        this.state.checked === 1 ?
                                            <FormGroup>
                                                <Col lg={3}>
                                                    <ControlLabel>
                                                        Nowy kierowca
                                                    </ControlLabel>
                                                    <TopSelect onChange={(e) => this.setState({nowykierowca: e})}
                                                               value={this.state.nowykierowca}
                                                               options={this.props.kierowcy}
                                                               valueKey={'idKi'} labelKey={'informacje'}
                                                               optionRenderer={this.renderKierowcaSelect}
                                                               valueRenderer={this.renderKierowcaSelect}
                                                    />
                                                </Col>
                                                <Col xs={12} lg={2}>
                                                    <ControlLabel>
                                                        Typ płatności
                                                    </ControlLabel>
                                                    <TopSelectSlownik restUrl={AppConfig.HOST_API() + 'slownik/byNazwa/OBSADA_TYP_PLATNOSCI'}
                                                                      onChange={(e) => {
                                                                          this.setState({typplatnosci: e})
                                                                      }}
                                                                      valueKey={'id'} labelKey={'wartosc'}
                                                    />
                                                </Col>
                                                <TopIf
                                                    isTrue={Boolean(this.state.typplatnosci) ? this.state.typplatnosci.wartosc == 'EXTRA' : false}>
                                                    <Col xs={12} lg={1}>
                                                        <ControlLabel>
                                                            Stawka
                                                        </ControlLabel>
                                                        <FormControl type={'number'} onChange={(e) => {
                                                            this.setState({stawka: e.target.value})
                                                        }}/>
                                                    </Col>
                                                </TopIf>
                                                <Col lg={2}>
                                                    <div className={'add-label-margin'}></div>
                                                    <TopButtonAction onClick={this.onClickZapisz}
                                                                     text={'Zapisz zmiany'}
                                                                     iconType={'fa fa-retweet'}
                                                                     btnColor={'primary'}
                                                                     btnSize={'md'}

                                                    />
                                                </Col>
                                            </FormGroup>
                                            :
                                            <FormGroup>
                                                <Col xs={12} lg={4}>
                                                    <ControlLabel>Nowy pojazd</ControlLabel>
                                                    <TopSelect onChange={(e) => this.setState({nowypojazd: e})}
                                                               value={this.state.nowypojazd}
                                                               options={this.props.pojazdy}
                                                               valueKey={'idPo'} labelKey={'informacje'}
                                                               optionRenderer={this.renderPojazdSelect}
                                                               valueRenderer={this.renderPojazdSelect}
                                                    />
                                                </Col>
                                                <Col lg={2}>
                                                    <div className={'add-label-margin'}></div>
                                                    <TopButtonAction onClick={this.onClickZapisz}
                                                                     text={'Zapisz zmiany'}
                                                                     iconType={'fa fa-retweet'}
                                                                     btnColor={'primary'}
                                                                     btnSize={'md'}

                                                    />
                                                </Col>
                                            </FormGroup>
                                    }

                                    <FormGroup>
                                        <ValidatorMessages messages={this.state.validateMessages}/>
                                    </FormGroup>
                                </Form>
                            </fieldset>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaZamiana/ObsadaZamianaContainer.js